import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const dynamicBaseQuery = async (args, api, extraOptions) => {
  //const state = api.getState();
  //const companyName = state?.auth?.companyName?.trim().replace(/\s+/g, '');
  const envport = process.env.REACT_APP_PORT_POSTAGE_DATA;
  const environment = process.env.REACT_APP_ENV;;
  // Determine the baseUrl based on the stdevate.

  const baseUrl =
  environment === "production" || environment === "prod"
    ? `https://demo.order2ucloud.com/${envport}`
    : `https://demo.${environment}.order2ucloud.com/${envport}`;
    
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    // prepareHeaders: (headers, { getState }) => {
    //   const token = getState().auth.token;
    //   if (token) {
    //     headers.set("authorization", `Bearer ${token}`);
    //   }
    //   return headers;
    // },
  });

  // 3. Call the raw base query with the original arguments.
  return rawBaseQuery(args, api, extraOptions);
};
//const token = " ";

// Define our single API slice object
export const apiSlice = createApi({
  reducerPath: "api",
  // 2. Use the custom dynamicBaseQuery function here.
  baseQuery: dynamicBaseQuery,
  tagTypes: ["postageData"],
  endpoints: (builder) => ({
    getPostageData: builder.query({
      query: () => "/posts",
      providesTags: ["postageData"],
    }),
    addPostageData: builder.mutation({
      query: (postageData) => ({
        url: "/mcoe/postage/saveData",
        method: "POST",
        headers:{ "customToken": process.env.REACT_APP_CUSTOM_TOKEN},
        body: postageData,
      }),
      invalidatesTags: ["postageData"],
    }),
    getMasterKeyList: builder.mutation({
      query: ({ companyNumber }) => ({
        url: "/mcoe/postage/getMasterNumber",
        method: "POST",
        headers:{ "customToken": process.env.REACT_APP_CUSTOM_TOKEN},
        body: {  "companyNumber": companyNumber },
      }),
      invalidatesTags: ["postageData"],
    }),
  }),
});

// Export the auto-generated hook for the `getPosts` query endpoint
export const { useGetPostageDatasQuery, useAddPostageDataMutation, useGetMasterKeyListMutation } = apiSlice;
